import React, { Component } from 'react';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import { map, cloneDeep, findIndex, keyBy, groupBy, isEqual } from 'lodash';
import CustomPanel from './CustomPanel';
import PageLoader from '../common/PageLoader';
import Button from '../common/Button';
import EmptyState from '../EmptyState/EmptyState';
import { imageBasePath } from '../../constants/staticData';
import CustomModal from '../common/CustomModal';
import { Modal } from 'react-bootstrap';
class CustomPanelGroup extends Component {
  constructor(props) {
    super(props);
    let check = findIndex(props.serviceData, (service) => {
      return service.status == 0 || service.status == null;
    });
    this.state = {
      isButtonLoading: false,
      clickedTab: '',
      showModal: false,
      isLoaded: props.isLoaded,
      serviceToggleSwitch: check == -1 ? true : false,
      carService: props.serviceData,
    };
    this.handleTabSwitch = this.handleTabSwitch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer.hideButtonLoader && this.state.isButtonLoading) {
      // this.props.actions.hideToastMessage();
      if (((nextProps.serviceType == 'carservice' && !nextProps.vendorProfileReducer.garageServicesError.serviceError) ||
        (nextProps.serviceType == 'carrepair' && !nextProps.vendorProfileReducer.garageServicesError.repairError)) && nextProps.buttonLabel == 'Next') {
        this.props.btnCallBack();
      }
      this.setState({ 'isButtonLoading': false });
    }
    if (!this.state.carService || this.state.carService.length === 0) {
      let check = findIndex(nextProps.serviceData, (service) => {
        return service.status == 0 || service.status == null;
      });
      this.setState({ carService: nextProps.serviceData, serviceToggleSwitch: check == -1 ? true : false });
    }
  }

  serviceToggleFunc() {
    let carServiceCopy = cloneDeep(this.state.carService);
    map(carServiceCopy, (service, key) => {
      carServiceCopy[key].status = !this.state.serviceToggleSwitch ? 1 : 0;
    });
    this.setState({ serviceToggleSwitch: !this.state.serviceToggleSwitch, carService: carServiceCopy });
  }

  handleCheckboxClick(categoryIndex, type) {
    let copyCarService = cloneDeep(this.state.carService);
    let index = findIndex(copyCarService, { id: categoryIndex });
    if (index != -1) {
      copyCarService[index].status = type.target.checked ? 1 : 0;
    }
    let check = findIndex(copyCarService, (service) => {
      return service.status == 0 || service.status == null;
    });
    this.setState({ carService: copyCarService, serviceToggleSwitch: check == -1 ? true : false });
  }

  checkInspection(serviceId){
    let copyCarService = cloneDeep(this.state.carService);
    let index = findIndex(copyCarService, { id: serviceId });
    if (index != -1) {
      copyCarService[index].isinspectionrequired = !copyCarService[index].isinspectionrequired;
      if(copyCarService[index].isinspectionrequired){
        copyCarService[index].inspectionamount = 0;
        copyCarService[index].paidInspection = false;
      }
    }
    this.setState({ carService: copyCarService });
    };

    onChangeToggleInsp(serviceId){
      let copyCarService = cloneDeep(this.state.carService);
      let index = findIndex(copyCarService, { id: serviceId });
      if (index != -1) {
         copyCarService[index].paidInspection = !copyCarService[index].paidInspection;
         if(!copyCarService[index].paidInspection){
           copyCarService[index].inspectionamount = 0;
         }
      }
      this.setState({ carService: copyCarService });
    }

    onInspecPriceChange(amount,serviceId){
      let copyCarService = cloneDeep(this.state.carService);
      let index = findIndex(copyCarService, { id: serviceId });
      if (index != -1) {
         copyCarService[index].inspectionamount = Number(amount);
      }
      this.setState({ carService: copyCarService });
    }

  priceChanged(carType, price, categoryIndex) {
    let copyCarService = cloneDeep(this.state.carService);
    let index = findIndex(copyCarService, { id: categoryIndex });
    if (index != -1) {
      if (carType == 'sedan') {
        copyCarService[index].cost_sedan = price ? price : null;
      } else if (carType == 'suv') {
        copyCarService[index].cost_suvs = price ? price : null;
      }
    }
    this.setState({ carService: copyCarService });
  }

  descpChanged(carType, descp, categoryIndex) {
    let copyCarService = cloneDeep(this.state.carService);
    let index = findIndex(copyCarService, { id: categoryIndex });
    if (index != -1) {
      if (carType == 'sedan') {
        copyCarService[index].descp_sedan = descp ? descp : '';
        copyCarService[index].descp_suv = copyCarService[index].descp_suv ? copyCarService[index].descp_suv : '';
      } else if (carType == 'suv') {
        copyCarService[index].descp_suv = descp ? descp : '';
        copyCarService[index].descp_sedan = copyCarService[index].descp_sedan ? copyCarService[index].descp_sedan : '';
      }
    }
    this.setState({ carService: copyCarService });
  }


  handleTabSwitch(tabName) {
    if (!isEqual(this.props.serviceData, this.state.carService)) {
      this.setState({ showModal: true, clickedTab: tabName });
    } else {
      this.props.tabClickSwitch(tabName);
    }
  }

  render() {
    const { isLoaded, btnCallBack, actions, serviceData, topLevelServiceData, parentServiceData, buttonLabel, hide } = this.props;
    let groupedCarService = groupBy(this.state.carService, "parentId");
    groupedCarService = keyBy(groupedCarService, (services) => {
      return services && services.length && services[0] && services[0].parentTitle;
    });
    return (
      <div className={hide ? 'hide' : ''}>
        {serviceData && serviceData.length ? <span className="toggle-switch toggleBtn s-selection-box">
          <span>Select All</span>
          <ToggleSwitch
            checked={this.state.serviceToggleSwitch}
            onChange={() => this.serviceToggleFunc()}
            size="small"
          />
        </span> : ''}
        <div className="selection-box">
          {isLoaded ? serviceData && serviceData.length ?
            map(groupedCarService, (serviceData, key) => {
              return (
                <CustomPanel
                  key={key}
                  title={key}
                  carServiceData={serviceData}
                  checkboxClick={(categoryIndex, type) => { this.handleCheckboxClick(categoryIndex, type); }}
                  priceChanged={this.priceChanged.bind(this)} 
                  descpChanged={this.descpChanged.bind(this)}
                  checkInspection={this.checkInspection.bind(this)} 
                  onChangeToggleInsp={this.onChangeToggleInsp.bind(this)}
                  onInspecPriceChange={this.onInspecPriceChange.bind(this)}/>
              );
            })
            : <EmptyState image={`${imageBasePath}/empty_service.png`} message={'This Service is Currently unavailable'} /> : <PageLoader />
          }
        </div>
        {serviceData && serviceData.length ? <span className="ms-button">
          <Button
            btnType="red"
            btnSize="sm"
            fontSize={15}
            label={buttonLabel}
            btnCallBack={() => {
              actions.addGarageServices(this.state.carService, serviceData, false, parentServiceData, topLevelServiceData);
              // buttonLabel == 'Next' && btnCallBack();
              this.setState({ isButtonLoading: true });
            }}
            isButtonLoading={this.state.isButtonLoading}
          />
        </span> : ''}
        <CustomModal className="decline-modal" showModal={this.state.showModal} footer="true" title="Save Changes" hideModal={() => this.setState({ showModal: false })} saveText="Save" submitCallBack={() => {
          actions.addGarageServices(this.state.carService, serviceData, false, parentServiceData, topLevelServiceData);
          this.setState({ showModal: false });
          this.props.tabClickSwitch(this.state.clickedTab);
        }}>
          <Modal.Body>
            <div>
              <span className="caption-result">Do you want to save the changes you just made?</span>
            </div>
          </Modal.Body>
        </CustomModal>
      </div>
    );
  }
}

export default CustomPanelGroup;



// WEBPACK FOOTER //
// ./src/components/ManageServices/CustomPanelGroup.jsx